import styled from 'styled-components';

export const TipsPageWrapper = styled.div`
  display : flex;
  flex-direction: column;
  height:100%;
  align-items: center;
`;

export const TipsHeader = styled.div`
  font-size: 1.6em ;
  text-align: center;
  margin:10px;
`;

export const TipsButtonPanel = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  height:30px;
  margin:10px;
  width: 100%;
`;

export const TipsBody = styled.div`
  flex-grow:1;
  display: flex;
    flex-direction: column;
    align-items: center;
  padding:5px;
`;

export const TipsGrouping = styled.div`
  display: grid;
  grid-template-columns : 2fr 2fr 1fr;
  justify-content: space-between;
  margin:10px;
  &> input {
    width: 70px;
  }
  width:100%;
  grid-row-gap: 5px;
`;

export const TipsActionButton = styled.button`
  border:none;
  background-color : transparent;
  cursor:pointer;
  &:focus {outline:0;}
  font-weight:bold;
`;
